import { LuiButton } from '@linzjs/lui';
import { LuiButtonProps } from '@linzjs/lui/dist/components/LuiButton/LuiButton';
import { forwardRef, PropsWithChildren, useContext } from 'react';

import { LuiModalAsyncInstanceContext } from './LuiModalAsyncInstanceContext';

/**
 * Wrapper for buttons at the bottom of model.
 */
export const LuiModalAsyncButtonGroup = ({ children }: PropsWithChildren<unknown>) => (
  <div className={'LuiModalAsync-ButtonGroup'}>{children}</div>
);

/**
 * Calls model close on click.
 */
export const LuiModalAsyncButtonDismiss = forwardRef<HTMLButtonElement, LuiButtonProps & { autofocus?: boolean }>(
  function LuiModalAsyncButtonDismiss(props, ref) {
    return (
      <LuiButton
        {...props}
        {...(props.level ? {} : { level: 'tertiary' })}
        {...(props.autofocus ? { buttonProps: { 'data-autofocus': true } } : {})}
        ref={ref}
        onClick={useContext(LuiModalAsyncInstanceContext).close}
      >
        {props.children}
      </LuiButton>
    );
  },
);

/**
 * Resolves to value on click, or if onClick is specified calls onClick.
 */
export const LuiModalAsyncButtonContinue = forwardRef<
  HTMLButtonElement,
  LuiButtonProps & { value?: unknown; autofocus?: boolean }
>(function LuiModalAsyncButtonContinue(props, ref) {
  const { resolve } = useContext(LuiModalAsyncInstanceContext);
  return (
    <LuiButton
      {...props}
      {...(props.level ? {} : { level: 'primary' })}
      {...(props.autofocus ? { buttonProps: { 'data-autofocus': true } } : {})}
      ref={ref}
      onClick={(e) => {
        if (props.onClick) props.onClick(e);
        else resolve(props.value ?? 'continue');
      }}
    >
      {props.children}
    </LuiButton>
  );
});
